import { useEffect, useState } from 'react';
import { createContext, useContext} from 'react';
import {
    getAuth,
    GoogleAuthProvider,
    signInWithPopup,
    signOut,
} from 'firebase/auth';
import {app} from './libs/Firebase'
import { doc, setDoc } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
export const Register = createContext();

const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app)

export const RegisterProvider = ({ children }) => {
    // ログインユーザ
    const [loginUser, setLoginUser] = useState();

    // 起動時ログイン処理(既にログインしてる場合, ユーザ設定)
    useEffect(() => {
        // auth 初期化時にログインユーザ設定
        auth.onAuthStateChanged((user) => setLoginUser(user));
    }, []);

    // ログイン処理
    const login = async () => {
        // Google ログインのポップアップ表示して認証結果取得
        const result = await signInWithPopup(auth, provider);
        // 認証結果より user 設定
        setLoginUser(result.user);
        register(result.user)
        localStorage.setItem('email', result.user.email);
    };
    function register(user){
        const cityRef = doc(db, 'users',user.email);
        setDoc(cityRef, { email: user.email}, { merge: true }).then(a => window.location.reload());
    }

    // ログアウト処理
    const logout = async () => {
        await signOut(auth);
        setLoginUser(null);
        localStorage.removeItem('email');
        localStorage.removeItem('name');
        window.location.reload()
    };
    // ログイン情報設定したProvider
    return (
        <Register.Provider
            value={{
                loginUser,
                login,
                logout,
            }}
        >
            {children}
        </Register.Provider>
    );
};

// RegisterConsumer (useContext) # Provider で囲った範囲で使う必要あり
export const RegisterConsumer = () => {
    return useContext(Register);
};
